export default __webpack_public_path__ + "static/dejavu_z8-41806464aab8aa51f7a1d8446dcf7294.png";